export const iconFontAwesomeMedicalHealthBacteria = (
	<i className="fa-solid fa-bacteria"></i>
);
